/**
 * Use it to simplify variables definitions with styleMap. CSS will fail to recognize that
 * the variable has the value "undefined"; it must not be present in the object.
 */
export function onlyDefined(cssVariables) {
    return Object.keys(cssVariables).reduce((acc, variableName) => {
        const variableValue = cssVariables[variableName];
        if (variableValue === undefined ||
            variableValue === null ||
            (typeof variableValue === 'string' && variableValue.length === 0)) {
            return acc;
        }
        acc[variableName] = variableValue;
        return acc;
    }, {});
}
//# sourceMappingURL=style.js.map